export const getClassYear = (educationSummary) => {
  return (
    educationSummary
      ?.map((edu) => edu.classYear)
      .filter(Boolean)
      .join(', ') || ''
  )
}

export const getUniqueCollegeAndDegree = (educationSummary, field) => {
  if (!educationSummary) return ''
  const classYear = educationSummary?.[0]?.classYear
  const multipleCollegeDegreeValues = educationSummary?.[0]?.degreeCollegeMapping?.map((edu) => edu[field])
  const notNullCollegeDegreeValues = multipleCollegeDegreeValues?.filter((element) => element !== null)

  if (!classYear) {
    if (notNullCollegeDegreeValues?.length > 0) {
      return notNullCollegeDegreeValues?.[0]
    }
  }
  if (classYear) {
    if (notNullCollegeDegreeValues?.length > 0) {
      return `${notNullCollegeDegreeValues?.[0]} (${classYear})`
    } else {
      const multipleCollegeDegreeValues = educationSummary
        .flatMap((item) => item.degreeCollegeMapping.map((edu) => edu[field]))
        .filter(Boolean)
      if (multipleCollegeDegreeValues?.length > 0) {
        return `No data found (${classYear})`
      }
    }
  }
}

export const getShowPopperArrow = (educationSummary, field) => {
  if (!educationSummary) return false
  const educationSummaryLength = educationSummary?.length || 0

  if (educationSummaryLength > 1) {
    const multipleCollegeDegreeValues = educationSummary
      ?.slice(1)
      .map((item) => getUniqueCollegeAndDegree([item], field))
      .filter(Boolean)
    return multipleCollegeDegreeValues.length > 0
  } else {
    const multipleCollegeDegreeValues = educationSummary?.[0]?.degreeCollegeMapping?.map((edu) => edu[field])
    const notNullCollegeDegreeValues = multipleCollegeDegreeValues?.filter((element) => element !== null)
    return notNullCollegeDegreeValues?.length > 1
  }
}
